export default __webpack_public_path__ + "static/media/bamboo.ea8b9085.png";